import { IBranch } from 'app/shared/Domains/branch';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { WebcamImage } from 'ngx-webcam';
import { ConfirmationService, MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { MemberService } from 'common/services/member.service';
import { Configuration } from 'config/config';
import { IAddress } from '../../Domains/address';
import { ICompany } from '../../Domains/company';
import { Customerstrainer } from '../../Domains/Customerstrainer';
import { IMemberFeeDetails } from '../../Domains/feeDetail';
import { IUser } from '../../Domains/IUser';
import { IMember } from '../../Domains/member';
import { IMemberContact } from '../../Domains/memberContact';
import { IMemberEmergencyContact } from '../../Domains/memberEmergencyContact';
import { IMemberFreezeDetail } from '../../Domains/memberFreezeDetail';
import { IPackageBuider } from '../../Domains/packageBuilder';
import { ISettings } from '../../Domains/settings';
import { ReceiptPrintComponent } from '../../receipt/receipt-print/receipt-print.component';
import globalVariable from "../../../../globalVariable/globalVariable.json";
import { async } from '@angular/core/testing';
import { AppUtils } from 'common/services/app.util';
import {
    buildCreateCustomerPayload,
    buildMemberUpdatePayload,
    customerCreateUrl,
    customerGetUrl,
    customerUpdateUrl,
} from 'common/services/member-update-payload.util';
import {
    billingStatusUrl,
    buildBillingStatusPayload,
    parseLocalBillingDate,
} from 'common/services/customer-fees-payload.util';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: 'app-add-multiple-signup',
    templateUrl: './add-multiple-signup.component.html',
    host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
    styleUrls: ['./add-multiple-signup.component.css']
})
export class AddMultipleSignupComponent implements OnInit {
    restrictCNICInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  const numericValue = input.value
    .replace(/[^0-9]/g, '')
    .slice(0, 13);

  input.value = numericValue;
  this.member.CNIC = numericValue;
}
    currentUser = '';
    companySessionStorage = '';
    branchSessionStorage = '';
[x: string]: any;
    @ViewChild("memberSignUpForm") memberSignUpForm: NgForm
    @ViewChild(ReceiptPrintComponent)
    private receiptComponent: ReceiptPrintComponent;
    member: IMember;
     @ViewChild("memberName") membernameInput: ElementRef;
    // @ViewChild("packageName", { static: false }) packageNameInput: ElementRef;
    @ViewChild("gender") genderControl: ElementRef;
    @ViewChild("dd") dropdown;
    packages: IPackageBuider[] = [];
    sourcePackages: IPackageBuider[];
    errorExempleNumber: any;
    addProfileImage: any;
    package: IPackageBuider;
    user: IUser;
    passwordType: string = "password";
    loading: boolean;
    items: any[];
    fund: IMemberFeeDetails;
    freezeDetail: IMemberFreezeDetail;
    activeIndex: any;
    company: ICompany;
    branch: IBranch;
    uploadProfile: any = [];
    counterImage = 0;
    bool: boolean;
    isAgeValid : boolean = true;
    selectecPackage: IPackageBuider;
    uploadProfilePath: any;
    sortedTrainers: any[];
    Trainers: any[];
    sourceTrainers: any[];
    options: any[] = [];
    x: Boolean;
    // isTrainer: Boolean;
    registrationFund: IMemberFeeDetails;
    trainerFund: IMemberFeeDetails;
    memberIDS: any[];
    selectedOption: any;
    fundInvoice: IMemberFeeDetails;
    dialogVisibility: boolean;
    feeInvoiceDialog: boolean;
    statusOptions: any[];
    months: any[];
    years: any[];
    referralOptions: any[];
    referralOther:any;
    public webcamImage: WebcamImage = null;
    feesServicesCall: any[] = [];
    memeberServicesCall: any[] = [];
    noOfMembers: number = 1;
    index: number = 0;
    memberItems: any[] = [];
    members: IMember[] = [];
    memberDrafts: { [index: number]: IMember } = {};
    currentMemberIndex: number = 0;
    isMembersRegistered: boolean = false;
    totalPackageFee: number = 0;
    totalRegistrationPackageFee: number = 0;
    totalTrainerFee: number = 0;
    existMembers: IMember[] = [];
    existMembersddOptions: any[] = [];
    existingMembersDialog: boolean = false;
    selectedExistMember: any;
    countries: any[] = [];
    memberAlreadySelected: Boolean;
    @Input() subPackage: IPackageBuider;
    @Input() availablePackages: IPackageBuider[] = [];
    @Output('changeWizard') changeWizard: EventEmitter<any> = new EventEmitter();
    @Output('reverseWizard') reverseWizard: EventEmitter<void> = new EventEmitter<void>();
    @Output('feeData') feeData: EventEmitter<any> = new EventEmitter();
    invoicePrint: boolean = false;
    genderOptions: { label: string; value: string }[];
    focusedIdx: any;
    count: number = 0;
    enterSteps: any[];
    currentStep: any;
    isEmailExist: boolean = false;
    isEmailLoader: boolean = false;
    timer: any;
    isDisableOnTypeEmail: boolean;
    isGymShareMoreThanTrainerFee: boolean = false;
    key: any = 0;

    goBack() {
        if (this.currentMemberIndex === 0) {
            this.reverseWizard.emit();
            return;
        }

        this.memberDrafts[this.currentMemberIndex] = this.member;
        this.currentMemberIndex--;
        this.member = this.members[this.currentMemberIndex];
        this.index = 0;
        this.isPhoneValid = true;
        this.isMembersRegistered = false;
    }

  isCurrentMemberFinal(): boolean {
    if (this.subPackage?.isGreaterthanNoOfMembers) {
        return this.currentMemberIndex >= this.noOfMembers - 1;
    }

    return this.currentMemberIndex === this.noOfMembers - 1;
}
    getCurrentMemberNumber(): number {
        return this.currentMemberIndex;
    }

    dbEmailIfCustomerHAve: any;
    isPreviouslyAddedEmailsMatchWithCurrentOne: boolean = false;
    sessionCount: any;
    relatedMemberData = [];
    formattedNumber: string = '';
    isPhoneValid: boolean = true;
    dateOfBirthError: boolean = false;
    selectedIdentityType: string = 'CNIC';
    bloodGroupOptions: any[] = [];
    registerConfirmVisible = false;

    constructor(
        private LanguageService: LanguageService,
        private router: Router,
        private route: ActivatedRoute,
        private confirmationService: ConfirmationService,
        public config: Configuration,
        private _http: HttpClient,
        private appServiceManager: AppServiceManager,
        private messageService: MessageService,
        private loader: NgxSpinnerService,
        private elementRef: ElementRef
    ) { }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AddMultipleSignupComponent", label);
      }
      get matchingLimitPackages(): IPackageBuider[] {
  return (this.availablePackages || []).filter(
    (packageItem) =>
      Number(packageItem.noOfMembers) === Number(this.subPackage?.noOfMembers)
  );
}
onPackageChange(selectedPackage: IPackageBuider) {
  if (!selectedPackage) {
    return;
  }

  this.subPackage = selectedPackage;
  this.noOfMembers = selectedPackage.noOfMembers;

  const updateMemberPackage = (member: IMember) => {
    if (!member) {
      return;
    }

    member.packageId = selectedPackage._id;
    member.packageName = selectedPackage.packageName;
    member.packageType = selectedPackage.packageType;
    member.monthFee = selectedPackage.packageFee.toString();
member.customerPackageFee = selectedPackage.packageFee;
    member.registerationFee =
      selectedPackage.registerationFee.toString();

    if (member.freezeDetail) {
      member.freezeDetail.totalFreezingDays =
        selectedPackage.freezingDays;
    }
  };

  updateMemberPackage(this.member);
  this.members.forEach((member) => updateMemberPackage(member));
}

    ngOnInit() {
        this.bloodGroupOptions = [
            { label: 'Select Blood Group', value: null },
            { label: 'A+', value: 'A+' },
            { label: 'A-', value: 'A-' },
            { label: 'B+', value: 'B+' },
            { label: 'B-', value: 'B-' },
            { label: 'AB+', value: 'AB+' },
            { label: 'AB-', value: 'AB-' },
            { label: 'O+', value: 'O+' },
            { label: 'O-', value: 'O-' }
        ];
        this.InitObjects();
        this.errorExempleNumber = globalVariable.exampledata.pakNumber;
        this.user = AuthService.getLoggedInUser();
        // this.getPackages();
        this.getMembers();
        this.memberAlreadySelected = false;
        this.activeIndex = 0;
        this.member.feeDetails = [];
        this.member.joiningDate = new Date();
        this.member.profile = "assets/layout/images/avatarBoyImage.png";
        this.member.gender = "M";
        this.member.question1 = "NO";
        this.dialogVisibility = false;
        this.loading = false;
        this.feeInvoiceDialog = false;
        this.x = false;
        // this.isTrainer = false;
        this.member.registerationFee = "0";
        this.getTrainers();
        this.getCompany();
        this.getAutoMemberID();
        this.selectSubcription();
        const enquiry = this.route.snapshot.queryParamMap.get("enquiry");
        if (enquiry != null) {
            this.getEnquiryMember();
        }
        this.currentStep = -1;

        this.currentUser = localStorage.getItem('currentUser');
        const currentUseroBJ = JSON.parse(this.currentUser);
        this.companySessionStorage = currentUseroBJ.company;
        this.branchSessionStorage = currentUseroBJ.branch;
        this.branch = JSON.parse(localStorage.getItem('currentBranch'));

    }

    InitObjects() {
        this.addProfileImage = "Upload";
        this.member = new IMember();
        this.company = new ICompany();
        this.member.contactDetail = new IMemberContact();
        this.freezeDetail = new IMemberFreezeDetail();
        this.member.freezeDetail = this.freezeDetail;
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail.address = new IAddress();
        this.member.customerstrainer = new Customerstrainer();
        this.member.settings = new ISettings();
        this.fund = new IMemberFeeDetails();
        this.fundInvoice = new IMemberFeeDetails();
        this.package = new IPackageBuider();
        this.user = new IUser();
        this.member.contactDetail.address.country = "Pakistan";
        // this.member.contactDetail.address.city = "Islamabad";
        this.statusOptions = [
            { label: "Select Fee Type", value: null },
            { label: "All", value: "All" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];

        this.months = [
            { label: "Select Month", value: null },
            { label: "January", value: 1 },
            { label: "Febuary", value: 2 },
            { label: "March", value: 3 },
            { label: "April", value: 4 },
            { label: "May", value: 5 },
            { label: "June", value: 6 },
            { label: "July", value: 7 },
            { label: "August", value: 8 },
            { label: "September", value: 9 },
            { label: "October", value: 10 },
            { label: "November", value: 11 },
            { label: "December", value: 12 },
        ];
        this.referralOptions = [
            { label: "Select Referral Source", value: null },
            { label: "Social Media", value: "Social Media" },
            { label: "Corporate", value: "Corporate" },
            { label: "Walk-In", value: "Walk-In" },
            { label: "Referral", value: "Referral" },
            { label: "Other", value: "Other" }
        ];
        this.years = [
            { label: "Select Year", value: null },
            { label: "2015", value: 2015 },
            { label: "2016", value: 2016 },
            { label: "2017", value: 2017 },
            { label: "2018", value: 2018 },
            { label: "2019", value: 2019 },
            { label: "2020", value: 2020 },
            { label: "2021", value: 2021 },
            { label: "2022", value: 2022 },
            { label: "2023", value: 2023 },
            { label: "2024", value: 2024 },
            { label: "2025", value: 2025 },
            { label: "2026", value: 2026 },
            { label: "2027", value: 2027 },
            { label: "2028", value: 2028 },
            { label: "2029", value: 2029 },
            { label: "2030", value: 2030 },
            { label: "2031", value: 2031 },
            { label: "2032", value: 2032 },
            { label: "2033", value: 2033 },
            { label: "2034", value: 2034 },
            { label: "2035", value: 2035 },
            { label: "2036", value: 2036 },
            { label: "2037", value: 2037 },
            { label: "2038", value: 2038 },
            { label: "2039", value: 2039 },
            { label: "2040", value: 2040 },
        ];

        this.enterSteps = [
            "memberName",
            "gender",
            "contact",
            "email",
            "street",
            "city",
            "country",
            "question1",
            "description",
            // "proceed"
        ];
    }

    getMembers() {
        this.members = [];
        this.existMembersddOptions = [];
        this.loading = true;
        this.appServiceManager
            .get(
                "branches/" +
                this.user.branch +
                "/customers"
            )
            .subscribe(
                (res: IMember[]) => {
                    const members = Array.isArray(res) ? res : ((res as any)?.customers ?? []);
                    if (members.length > 0) {
                        this.existMembers = members;
                        this.existingMemberOptions();
                    } else {
                        this.members = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error.error.message,
                    });
                }
            );
    }

    existingMemberOptions() {
        this.existMembersddOptions.push({
            label: "Select Member",
            value: null,
        }),
            (this.existMembersddOptions = this.existMembers
    .filter((member) =>
        String(member.packageId) === String(this.subPackage?._id)
    )
    .map(
                ({ _id, name, tagNumber }) => {
    var label = tagNumber + " - " + name;
    var value = _id;
    return { label, value };
}
            ));
    }

    getEnquiryMember() {
        let enquiryObj = JSON.parse(
            this.route.snapshot.queryParamMap.get("enquiry")
        );
        this.member = new IMember();
        this.member.contactDetail = new IMemberContact();
        this.member.contactDetail.address = new IAddress();
        this.member.contactDetail.address.street = enquiryObj.address;
        // this.member.contactDetail.address.city = "Islamabad";
        this.member.contactDetail.address.country = "Pakistan";
        this.member.customerstrainer = new Customerstrainer();
        this.member.name = enquiryObj.name;
        this.member.email = enquiryObj.email;
        this.member.CNIC = enquiryObj.CNIC;
        this.member.gender = enquiryObj.gender == "Male" ? "M" : "F";
        this.member.profile = enquiryObj.gender == "Male" ? "assets/layout/images/avatarBoyImage.png" : "assets/layout/images/avatarGirlImage.png";
        this.member.contactDetail.contact = enquiryObj.contact;
        this.member.customerstrainer.totalFees = undefined;
        this.member.question3 = "NO";
        // this.member.5.address = enquiryObj.address;
        this.member.profession = enquiryObj.profession;
        this.member.question2 = enquiryObj.question2;
        this.member.question1 = enquiryObj.question1;
        this.member.joiningDate = new Date();
    }

    // getPackages() {
    //     this.packages = [];
    //     this.loading = true;
    //     this.loader.show();
    //     this.appServiceManager
    //         .get(
    //             "packagesBuilder/company/" +
    //             this.user.company +
    //             "/branch/" +
    //             this.user.branch
    //         )
    //         .subscribe(
    //             (res) => {
    //                 this.packages = res;
    //                 this.sourcePackages = res;
    //                 this.loading = false;
    //                 this.loader.hide();
    //             },
    //             (error) => {
    //                 this.loading = false;
    //                 this.messageService.clear();
    //                 this.messageService.add({
    //                     severity: "error",
    //                     summary: "Error Message",
    //                     detail: error,
    //                 });
    //             }
    //         );
    // }

    setSessionCount(value: any,selectedMember:IMember ) {
        this.sessionCount = value;
        this.dropdownChange1(selectedMember);
    }

    getAutoMemberID() {
        let filter = {
            Member: this.member.tagNumber,
            company: this.user.company,
            branch: this.user.branch,
        };
        this.appServiceManager
            .post('branches/' + this.user.branch + '/customers/actions/get-membership', filter)
            .subscribe(
                (member: any) => {
                    if (member.memberShipTag != null) {
                        this.member.tagNumber = member.memberShipTag.toString();
                    }
                },
                (error) => { }
            );
    }
    membershipValidation() {
        if (this.member.tagNumber != "") {
            this.appServiceManager
                .get(
                    "customers/membershipExistValidation/" +
                    this.member.tagNumber
                )
                .subscribe(
                    (res) => {
                        if (res.length > 0) {
                            this.x = true;
                        } else if (res.length == 1) {
                            this.x = true;
                        } else {
                            this.x = false;
                        }
                    },
                    (error) => { }
                );
        }
    }

    getPackageByID() {
        this.appServiceManager.get("branches/" + this.user.branch + "/package-builders/" + this.member.packageId).subscribe((res: any) => {
          this.selectecPackage = res;
          this.loading = false;
        },
        (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }

    dropdownChange() {
        var data = this.Trainers.filter((x) => x._id === this.selectedOption);
        if (data.length > 0) {
            this.member.customerstrainer.trainerId = data[0]._id;
            this.member.customerstrainer.name = data[0].name;
            this.member.customerstrainer.sessionCount = this.sessionCount;
            this.member.customerstrainer.remainingSessionCount = this.sessionCount;
            this.member.customerstrainer.dueDate = new Date(this.member.joiningDate);
            this.member.customerstrainer.totalFees = data[0].totalFees
                ? data[0].totalFees
                : 0;
            this.member.customerstrainer.trainerShare = data[0].trainerShare
                ? data[0].trainerShare
                : 0;
            this.member.customerstrainer.gymShare = data[0].gymShare
                ? data[0].gymShare
                : 0;
        }
    }

    dropdownChange1(selectedMember: IMember) {
        var _trainerObj = this.Trainers.find(
            (x) => x._id === selectedMember.customerstrainer.trainerId
        );
        var index = this.members.indexOf(selectedMember);
        var trainerfeeId = "trainerFees-" + index;
        var gymShareId = "gymShare-" + index;
        var trainerShareId = "trainerShare-" + index;
        // var trainerDueDateId = "trainerDueDate-" + index;

        let memberInd = this.members.find(
            (x) => x.tagNumber === selectedMember.tagNumber
        );
        let TrainerFeeId: any = document.getElementById(trainerfeeId);
        let GymShareId: any = document.getElementById(gymShareId);
        let TrainerShareId: any = document.getElementById(trainerShareId);
        // let eleDueDateId: any = document.getElementById(trainerDueDateId);

        if (_trainerObj != null) {
            this.isGymShareMoreThanTrainerFee = false;
            TrainerFeeId.disabled = false;
            GymShareId.disabled = false;
            // TrainerShareId.disabled = false;
            // eleDueDateId.disabled = false;
            // this.isTrainer = true;
            memberInd.question3 = "YES";
            memberInd.customerstrainer.trainerId = _trainerObj._id;
            memberInd.customerstrainer.name = _trainerObj.name;
            memberInd.customerstrainer.sessionCount = this.sessionCount;
            memberInd.customerstrainer.remainingSessionCount = parseInt(this.sessionCount);
            memberInd.customerstrainer.dueDate = new Date(memberInd.joiningDate);
            memberInd.customerstrainer.totalFees = _trainerObj.totalFees;
            memberInd.customerstrainer.trainerShare = _trainerObj.trainerShare
                ? _trainerObj.trainerShare
                : 0;
            memberInd.customerstrainer.gymShare = _trainerObj.gymShare
                ? _trainerObj.gymShare
                : 0;

        } else if (_trainerObj == undefined) {
            // this.isTrainer = false;
            TrainerFeeId.disabled = true;
            GymShareId.disabled = true;
            TrainerShareId.disabled = true;
            // eleDueDateId.disabled = true;
            memberInd.question3 = "NO";
            memberInd.customerstrainer.trainerId = undefined;
            memberInd.customerstrainer.name = undefined;
            memberInd.customerstrainer.dueDate = undefined;
            memberInd.customerstrainer.totalFees = undefined;
            memberInd.customerstrainer.trainerShare = undefined;
            memberInd.customerstrainer.gymShare = undefined;
        }
        this.members[index] = memberInd;
        this.count++;
    }

    getTrainers() {
        this.sourceTrainers = [];
        this.sortedTrainers = [];
        this.loading = true;
        this.appServiceManager.get('branches/' + this.user.branch + '/users/actions/trainers').subscribe(
            (res) => {
                if (res.length > 0) {
                    this.setTrainerData(res);
                } else {
                    this.Trainers = [];
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Trainer Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }

    setTrainerData(Trainers) {
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == false) {
                this.sortedTrainers.push(Trainers[i]);
            }
        }
        this.sortedTrainers.sort(function (a, b) {
            if (
                a.name.substring(0, 1).toLowerCase() <
                b.name.substring(0, 1).toLowerCase()
            ) {
                return -1;
            } else if (
                a.name.substring(0, 1).toLowerCase() >
                b.name.substring(0, 1).toLowerCase()
            ) {
                return 1;
            }
            return 0;
        });
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == true) {
                this.sortedTrainers.push(Trainers[i]);
            }
        }
        this.Trainers = this.sortedTrainers;
        this.sourceTrainers = this.sortedTrainers;
        this.Trainers = [...this.Trainers];
        this.sourceTrainers = [...this.sourceTrainers];
        this.options.push({ label: "Select Trainer", value: 0 });
        this.Trainers.forEach((trainer) => {
            this.options.push({ label: trainer.name, value: trainer._id });
        });
    }
    getCompany() {
        this.appServiceManager.get("companies/current").subscribe(
            (res) => {
                if (res) {
                    this.company = res;
                } else {
                    this.company = new ICompany();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }

            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }
    validateSignup() {
        if (this.activeIndex === 0) {
            this.activeIndex = 1;
            this.currentStep = 0;
        } else if (this.activeIndex === 1) {
            this.activeIndex = 2;
        }

    }

    skipMember() {
        if (this.index === 1) {
            this.index = 0;

            let ele = document.getElementsByClassName(
                "p-radiobutton-label-active"
            )[1] as HTMLElement;
            ele.focus();
            if (!this.subPackage.isGreaterthanNoOfMembers) {
                if (this.noOfMembers == this.members.length) {
                    this.isMembersRegistered = true;
                    let ele = document.getElementsByClassName(
                        "p-radiobutton-label-active"
                    )[1] as HTMLElement;
                    ele.focus();
                }
            } else {
                if (this.noOfMembers == this.members.length) {
                    this.isMembersRegistered = true;
                    let ele = document.getElementsByClassName(
                        "p-radiobutton-label-active"
                    )[1] as HTMLElement;
                    ele.focus();
                }
            }
        } else if (this.index === 0) {
            this.index = 1;
            this.enterSteps = [
                "selectTrainer-" + this.key,
                "trainerFees-" + this.key,
                "gymShare-" + this.key,
                "trainerShare-" + this.key,
            ];
            setTimeout(() => {
                this.selectTrainerFocusOnGroupTrainingPage();
            }, 1000);
            if (this.noOfMembers == this.members.length) {
                this.isMembersRegistered = true;
                let ele = document.getElementsByClassName(
                    "p-radiobutton-label-active"
                )[1] as HTMLElement;
                ele.focus();
            }
        } else {
            this.index = 1;
        }
    }

    isFieldRequired(fieldName: string): boolean {
        return this.branch?.requiredFieldsCustomer?.[fieldName] === true;
    }

    validateMembersSignup(form :any) {
        if (form.controls['name'].invalid) {
            const nameInput = document.getElementById('memberName');
            nameInput.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
        if (form.controls['dateOfBirth'].invalid) {
            const nameInput = document.getElementById('joiningDate');
            nameInput.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
        if (this.member.name) {
            if (this.members.indexOf(this.member) === -1) {
                this.members.push(this.member);
            }
        }
        if (this.index === 1) {
            this.index = 0;

            let ele = document.getElementsByClassName(
                "p-radiobutton-label-active"
            )[1] as HTMLElement;
            ele.focus();
            if (!this.subPackage.isGreaterthanNoOfMembers) {
                if (this.noOfMembers == this.members.length) {
                    this.isMembersRegistered = true;
                    let ele = document.getElementsByClassName(
                        "p-radiobutton-label-active"
                    )[1] as HTMLElement;
                    ele.focus();
                }
            } else {
                if (this.noOfMembers == this.members.length) {
                    this.isMembersRegistered = true;
                    let ele = document.getElementsByClassName(
                        "p-radiobutton-label-active"
                    )[1] as HTMLElement;
                    ele.focus();
                }
            }
        } else if (this.index === 0) {
            this.index = 1;
            this.enterSteps = [
                "selectTrainer-" + this.key,
                "trainerFees-" + this.key,
                "gymShare-" + this.key,
                "trainerShare-" + this.key,
            ];
            setTimeout(() => {
                this.selectTrainerFocusOnGroupTrainingPage();
            }, 1000);
            if (this.noOfMembers == this.members.length) {
                this.isMembersRegistered = true;
                let ele = document.getElementsByClassName(
                    "p-radiobutton-label-active"
                )[1] as HTMLElement;
                ele.focus();
            }
        }
        else {
            this.index = 1;
        }
    }
    validatePhoneNumber() {
        if (!this.member.contactDetail.contact) {
            this.memberSignUpForm.controls['phoneNumber'].setErrors({ required: true });
        }
    }
    selectSubcription() {

        this.member.monthFee = this.subPackage.packageFee.toString();
        this.member.question3 = "NO";
        this.member.packageType = this.subPackage.packageType;
        this.member.packageName = this.subPackage.packageName;
        this.member.packageId = this.subPackage._id;
        this.member.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
        this.noOfMembers = this.subPackage.noOfMembers;
        this.currentMemberIndex = 0;
        this.member.registerationFee = this.subPackage.registerationFee.toString();
        for (let index = 1; index <= this.noOfMembers; index++) {
            this.memberItems.push({
                label: "Membership" + " " + index,
                command: (event: any) => {
                    this.activeIndex = 0;
                    this.validateSignup();
                },
            });
        }
        // member register button check if
        if (this.noOfMembers == 1) {
            this.isMembersRegistered = true;
        }
        // TODO: Commented By Mahsam
        // this.index = 1;
        this.validateSignup();
    }

    nextMembers() {

        this.counterImage++;
        if (this.currentMemberIndex < this.members.length - 1) {
            this.members[this.currentMemberIndex] = this.member;
            this.memberDrafts[this.currentMemberIndex] = this.member;
            this.currentMemberIndex++;
            this.member = this.memberDrafts[this.currentMemberIndex] || this.members[this.currentMemberIndex];
            this.index = 0;
            this.isPhoneValid = true;
            this.isMembersRegistered = this.isCurrentMemberFinal();
            return;
        }

        // TODO: on members length check if it's less than to noOfMembers than intialize the Imember interface

        // TODO: on members length check if it's equal to noOfMembers &&  subPackage isGreaterthanNoOfMembers is false then proceed button enabled dont clear the fields

        // TODO: on member length check if it's equal to noofmembers && subPackage isGreaterthanNoOfMembers is true then intialize the Imember interface
        this.member.customerstrainer.dueDate = new Date(this.member.joiningDate);
        if (this.member !== this.members[this.members.length - 1]) {
            this.members.push(this.member);
        }
        this.currentMemberIndex = this.members.length;
        this.isPhoneValid = false;
        const nextMemberDraft = this.memberDrafts[this.members.length];
        if (nextMemberDraft) {
            this.member = nextMemberDraft;
            this.currentMemberIndex = this.members.length;
            this.index = 0;
            this.isPhoneValid = true;
            this.isMembersRegistered = this.members.length >= this.noOfMembers;
            return;
        }
        // if (!this.subPackage.isGreaterthanNoOfMembers && this.noOfMembers === this.members.length)
        if (this.subPackage.isGreaterthanNoOfMembers && this.members.length >= this.noOfMembers - 1) {
            this.isMembersRegistered = true;
            this.member = new IMember();
            setTimeout(() => {
                // this.membernameInput.nativeElement.focus();
                this.autoFocus();

                this.member.contactDetail.address.country = "Pakistan";
                //this.member.contactDetail.address.city = "Islamabad";
            }, 0);
            const newMembers = this.members.filter((x) => x._id == undefined); // get newly member to get the next tagNumber
            if (newMembers.length > 0) {
                this.member.tagNumber = String(
                    parseInt(newMembers[newMembers.length - 1].tagNumber) + 1
                ).toString();
            } else {
                this.getAutoMemberID();
            }
            this.member.packageId = this.subPackage._id;
            this.member.packageType = this.subPackage.packageType;
            this.member.packageName = this.subPackage.packageName;
            this.member.freezeDetail = new IMemberFreezeDetail();
            this.member.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
            this.member.profile = "assets/layout/images/avatarBoyImage.png";
            this.member.monthFee = this.subPackage.packageFee.toString();
            this.member.gender = "M";
            this.member.feeDetails = [];
            this.member.question3 = "NO";
            this.member.question1 = "NO";
            this.member.registerationFee =
                this.subPackage.registerationFee.toString();
            this.member.joiningDate = new Date();

            this.member.contactDetail = new IMemberContact();
            this.member.emergencyContact=new IMemberEmergencyContact();
            this.member.contactDetail.contact = "";
            this.member.customerstrainer = new Customerstrainer();
            // this.member.customerstrainer.totalFees = "0";
            this.member.gPTQuestion = "";
            this.member.contactDetail.address = new IAddress();
            this.member.contactDetail.address.street = "";
            this.index = 0;
        } else {
            this.member = new IMember();
            setTimeout(() => {
                // this.membernameInput.nativeElement.focus();
                this.autoFocus();

                this.member.contactDetail.address.country = "Pakistan";
                // this.member.contactDetail.address.city = "Islamabad";
            }, 0);
            const newMembers = this.members.filter((x) => x._id == undefined); // get newly member to get the next tagNumber
            if (newMembers.length > 0) {
                this.member.tagNumber = String(
                    parseInt(newMembers[newMembers.length - 1].tagNumber) + 1
                ).toString();
            } else {
                this.getAutoMemberID();
            }
            this.member.packageId = this.subPackage._id;
            this.member.packageType = this.subPackage.packageType;
            this.member.packageName = this.subPackage.packageName;
            this.member.freezeDetail = new IMemberFreezeDetail();
            this.member.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
            this.member.profile = "assets/layout/images/avatarBoyImage.png";
            this.member.monthFee = this.subPackage.packageFee.toString();
            this.member.gender = "M";
            this.member.feeDetails = [];
            this.member.question3 = "NO";
            this.member.question1 = "NO";
            this.member.registerationFee =
                this.subPackage.registerationFee.toString();
            this.member.joiningDate = new Date();
            this.member.contactDetail = new IMemberContact();
            this.member.emergencyContact=new IMemberEmergencyContact();
            this.member.contactDetail.contact = "";
            this.member.bloodGroup = "";
            console.log("NEXT MEMBER DEBUG", {
  emergencyName: this.member.emergencyContact.name,
  emergencyMobile: this.member.emergencyContact.contact,
  bloodGroup: this.member.bloodGroup
});
            this.member.customerstrainer = new Customerstrainer();
            // this.member.customerstrainer.totalFees = "0";
            this.member.gPTQuestion = "";
            this.member.contactDetail.address = new IAddress();
            this.member.contactDetail.address.street = "";
            this.index = 0;
        }
    }

    clearCustomerTrainer(value: any) {
        this.members.map((member) => {
            member.customerstrainer = new Customerstrainer();
            member.customerstrainer.totalFees = null;
            member.question3 = "NO";
            this.count = 0;
        })
    }

    // feeInvoice() {
    //     var date = new Date();
    //     this.feeInvoiceDialog = true;
    //     let packageMonths = 0;
    //     this.totalPackageFee = 0;
    //     this.totalRegistrationPackageFee = 0;
    //     this.totalTrainerFee = 0;
    //     let invoice = Math.round(Math.random() * 1000).toString();
    //     for (let index = 0; index < this.members.length; index++) {
    //         let member = this.members[index];
    //         let memberPackage: IPackageBuider = this.subPackage;
    //         member.packageId = memberPackage._id;
    //         member.packageType = memberPackage.packageType;
    //         // Month Wise Package: per Month Fee and whole package fee.
    //         if (
    //             memberPackage.packageType === "Month Wise Package" &&
    //             memberPackage.packageFeeType === "whole package fee"
    //         ) {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / packageMonths
    //             ).toString();
    //             member.customerPackageFee = parseInt(member.monthFee);
    //         } else if (
    //             memberPackage.packageType === "Month Wise Package" &&
    //             memberPackage.packageFeeType === "per Month Fee"
    //         ) {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / packageMonths
    //             ).toString();
    //             member.customerPackageFee =
    //                 packageMonths * parseInt(member.monthFee);
    //         }
    //         // Person Wise Package: per person Fee and whole package fee.
    //         else if (
    //             memberPackage.packageType === "Person Wise Package" &&
    //             memberPackage.packageFeeType === "whole package fee"
    //         ) {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / memberPackage.noOfMembers
    //             ).toString();
    //             member.customerPackageFee = parseInt(member.monthFee);
    //         } else if (
    //             memberPackage.packageType === "Person Wise Package" &&
    //             memberPackage.packageFeeType === "per Person Fee"
    //         ) {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / packageMonths
    //             ).toString();
    //             member.customerPackageFee =
    //                 packageMonths * parseInt(member.monthFee);
    //         } else {
    //             packageMonths = memberPackage.noOfMonths;
    //             member.monthFee = Math.round(
    //                 memberPackage.packageFee / packageMonths
    //             ).toString();
    //             member.customerPackageFee = parseInt(member.monthFee);
    //         }

    //         this.fund = new IMemberFeeDetails();
    //         this.fund.invoice = invoice;
    //         this.fund.day = new Date(member.settings.dueDate).getDate().toString();
    //         this.fundInvoice.invoice = this.fund.invoice;
    //         this.fundInvoice.date = date;
    //         this.fund.year = date.getFullYear();
    //         this.fund.month = date.getMonth() + 1;
    //         this.fund.pay = this.totalPackageFee;
    //         this.fund.date = new Date();
    //         // if per person registartion fee
    //         if (memberPackage.registerationFee != 0) {
    //             member.registerationFee =
    //                 memberPackage.registerationFee.toString();
    //             if (
    //                 memberPackage.packageRegFeeType ===
    //                 "per Person Registration Fee"
    //             ) {
    //                 this.registrationFund = { ...this.fund };
    //                 this.registrationFund.memberId = member._id;
    //                 this.registrationFund.pay = memberPackage.registerationFee;
    //                 this.registrationFund.status = "Registration Fee - Paid";
    //                 this.feesServicesCall.push(
    //                     this.appServiceManager.post(
    //                         "customers/payFund",
    //                         this.registrationFund
    //                     )
    //                 );
    //                 this.totalRegistrationPackageFee +=
    //                     this.subPackage.registerationFee;
    //             } //if whole package registartion fee
    //             else if (
    //                 memberPackage.packageRegFeeType ===
    //                 "whole package Registration fee" &&
    //                 this.members.length === 0
    //             ) {
    //                 this.registrationFund = { ...this.fund };
    //                 this.registrationFund.memberId = member._id;
    //                 this.registrationFund.pay = Math.round(
    //                     memberPackage.registerationFee /
    //                     memberPackage.noOfMembers
    //                 );
    //                 this.registrationFund.status = "Registration Fee - Paid";
    //                 this.feesServicesCall.push(
    //                     this.appServiceManager.post(
    //                         "customers/payFund",
    //                         this.registrationFund
    //                     )
    //                 );
    //                 this.totalRegistrationPackageFee +=
    //                     this.subPackage.registerationFee;
    //             }
    //         }

    //         // trainer fees add
    //         if (member.question3 === "YES") {
    //             this.trainerFund = { ...this.fund };
    //             this.trainerFund.memberId = member._id;
    //             this.trainerFund.pay = Math.round(
    //                 parseInt(member.customerstrainer.totalFees)
    //             );
    //             this.trainerFund.status = "Trainer Fee - Paid";
    //             this.feesServicesCall.push(
    //                 this.appServiceManager.post(
    //                     "customers/payFund",
    //                     this.trainerFund
    //                 )
    //             );
    //             this.totalTrainerFee += this.trainerFund.pay;
    //         }

    //         for (let index = 0; index <= packageMonths - 1; index++) {
    //             var terminDate = new Date();
    //             let fund = new IMemberFeeDetails();
    //             fund.memberId = member._id;
    //             fund.invoice = this.fund.invoice;
    //             terminDate.setMonth(terminDate.getMonth() + index);
    //             fund.month = terminDate.getMonth() + 1;
    //             fund.date = this.fundInvoice.date;
    //             fund.pay = parseInt(member.monthFee);
    //             fund.day = this.fund.day;
    //             fund.year = terminDate.getFullYear();
    //             fund.status = "Monthly Fee - Paid";
    //             this.feesServicesCall.push(
    //                 this.appServiceManager.post("customers/payFund", fund)
    //             );
    //             this.totalPackageFee += fund.pay;
    //         }
    //     }
    // }

    // feeInvoiceSolo(membercard) {
    //     var date = new Date();
    //     this.feeInvoiceDialog = true;
    //     let packageMonths = 0;
    //     this.totalPackageFee = 0;
    //     this.totalRegistrationPackageFee = 0;
    //     this.totalTrainerFee = 0;

    //     let myMember = this.members.find(
    //         (x) => x.tagNumber == membercard.tagNumber
    //     );
    //     let memberPackage: IPackageBuider = this.subPackage;
    //     myMember.packageId = memberPackage._id;
    //     myMember.packageType = memberPackage.packageType;

    //     if (
    //         memberPackage.packageType === "Month Wise Package" &&
    //         memberPackage.packageFeeType === "whole package fee"
    //     ) {
    //         packageMonths = memberPackage.noOfMonths;
    //         myMember.monthFee = Math.round(
    //             memberPackage.packageFee / packageMonths
    //         ).toString();
    //         myMember.customerPackageFee = parseInt(myMember.monthFee);
    //     } else if (
    //         memberPackage.packageType === "Month Wise Package" &&
    //         memberPackage.packageFeeType === "per Month Fee"
    //     ) {
    //         packageMonths = memberPackage.noOfMonths;
    //         myMember.monthFee = Math.round(
    //             memberPackage.packageFee / packageMonths
    //         ).toString();
    //         myMember.customerPackageFee =
    //             packageMonths * parseInt(myMember.monthFee);
    //     }
    //     // Person Wise Package: per person Fee and whole package fee.
    //     else if (
    //         memberPackage.packageType === "Person Wise Package" &&
    //         memberPackage.packageFeeType === "whole package fee"
    //     ) {
    //         packageMonths = memberPackage.noOfMonths;
    //         myMember.monthFee = Math.round(
    //             memberPackage.packageFee / memberPackage.noOfMembers
    //         ).toString();
    //         myMember.customerPackageFee = parseInt(myMember.monthFee);
    //     } else if (
    //         memberPackage.packageType === "Person Wise Package" &&
    //         memberPackage.packageFeeType === "per Person Fee"
    //     ) {
    //         packageMonths = memberPackage.noOfMonths;
    //         myMember.monthFee = Math.round(
    //             memberPackage.packageFee / packageMonths
    //         ).toString();
    //         myMember.customerPackageFee =
    //             packageMonths * parseInt(myMember.monthFee);
    //     } else {
    //         packageMonths = memberPackage.noOfMonths;
    //         myMember.monthFee = Math.round(
    //             memberPackage.packageFee / packageMonths
    //         ).toString();
    //         myMember.customerPackageFee = parseInt(myMember.monthFee);
    //     }

    //     this.fund = new IMemberFeeDetails();
    //     this.fund.invoice = Math.round(Math.random() * 1000).toString();
    //     this.fund.day = new Date(myMember.settings.dueDate)
    //         .getDate()
    //         .toString();
    //     this.fundInvoice.invoice = this.fund.invoice;
    //     this.fundInvoice.date = date;
    //     this.fund.year = date.getFullYear();
    //     this.fund.month = date.getMonth() + 1;
    //     this.fund.pay = this.totalPackageFee;
    //     this.fund.date = new Date();

    //     if (memberPackage.registerationFee != 0) {
    //         myMember.registerationFee =
    //             memberPackage.registerationFee.toString();
    //         if (
    //             memberPackage.packageRegFeeType ===
    //             "per Person Registration Fee"
    //         ) {
    //             this.registrationFund = { ...this.fund };
    //             this.registrationFund.memberId = myMember._id;
    //             this.registrationFund.pay = memberPackage.registerationFee;
    //             this.registrationFund.status = "Registration Fee - Paid";
    //             this.feesServicesCall.push(
    //                 this.appServiceManager.post(
    //                     "customers/payFund",
    //                     this.registrationFund
    //                 )
    //             );
    //             this.totalRegistrationPackageFee =
    //                 this.subPackage.registerationFee;
    //         } //if whole package registartion fee
    //         else if (
    //             memberPackage.packageRegFeeType ===
    //                 "whole package Registration fee" &&
    //             this.members.length === 0
    //         ) {
    //             this.registrationFund = { ...this.fund };
    //             this.registrationFund.memberId = myMember._id;
    //             this.registrationFund.pay = Math.round(
    //                 memberPackage.registerationFee / memberPackage.noOfMembers
    //             );
    //             this.registrationFund.status = "Registration Fee - Paid";
    //             this.feesServicesCall.push(
    //                 this.appServiceManager.post(
    //                     "customers/payFund",
    //                     this.registrationFund
    //                 )
    //             );
    //             this.totalRegistrationPackageFee =
    //                 this.subPackage.registerationFee;
    //         }
    //     }

    //     // trainer fees add
    //     if (myMember.question3 === "YES") {
    //         this.trainerFund = { ...this.fund };
    //         this.trainerFund.memberId = myMember._id;
    //         this.trainerFund.pay = Math.round(
    //             parseInt(myMember.customerstrainer.totalFees)
    //         );
    //         this.trainerFund.status = "Trainer Fee - Paid";
    //         this.feesServicesCall.push(
    //             this.appServiceManager.post(
    //                 "customers/payFund",
    //                 this.trainerFund
    //             )
    //         );
    //         this.totalTrainerFee = this.trainerFund.pay;
    //     }

    //     for (let index = 0; index <= packageMonths - 1; index++) {
    //         var terminDate = new Date();
    //         let fund = new IMemberFeeDetails();
    //         fund.memberId = myMember._id;
    //         fund.invoice = this.fund.invoice;
    //         terminDate.setMonth(terminDate.getMonth() + index);
    //         fund.month = terminDate.getMonth() + 1;
    //         fund.date = this.fundInvoice.date;
    //         fund.pay = parseInt(myMember.monthFee);
    //         fund.day = this.fund.day;
    //         fund.year = terminDate.getFullYear();
    //         fund.status = "Monthly Fee - Paid";
    //         this.feesServicesCall.push(
    //             this.appServiceManager.post("customers/payFund", fund)
    //         );
    //         this.totalPackageFee += fund.pay;
    //     }
    // }

    reverse() {
        if (this.activeIndex === 1) {
            this.activeIndex = 0;
        } else if (this.activeIndex === 2) {
            this.activeIndex = 1;
        }
    }
    togglePasswordType() {
        if (this.passwordType === "password") {
            this.passwordType = "text";
        } else {
            this.passwordType = "password";
        }
    }

    validateDetail(member: IMember) {
        // if (parseInt(member.registerationFee) >= 0 && parseInt(member.monthFee) >= 0) {
        if (
            member.question3 === "YES" &&
            parseInt(member.customerstrainer.totalFees) >= 0
        ) {
            return true;
        } else if (member.question3 === "NO") {
            member.customerstrainer.totalFees = '0';
            return true;
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Complete Fields Properly",
            });
            return false;
        }
    }
    onBloodGroupChange($event) {
        console.log("bloodGroup", $event);
        this.member.bloodGroup = $event.value;
    }
    async signup() {
        this.feesUpdate();
        var check = this.membersAdd();
        if (check) {
            const duplicateError = this.findDuplicateMemberDetailsError();
            if (duplicateError) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: duplicateError,
                });
                return;
            }

            this.loader.show();
            let existingMemberError: string | null = null;
            try {
                existingMemberError =
                    await this.validateExistingMembersBeforeSignup();
            } finally {
                this.loader.hide();
            }
            if (existingMemberError) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: existingMemberError,
                });
                return;
            }

            this.registerConfirmVisible = true;
        }
    }

    async confirmSignup(): Promise<void> {
        this.registerConfirmVisible = false;
        this.loader.show();
        const createdCustomerIds: string[] = [];
        const formMembersSnapshot = [...this.members];
        try {
            const res = [];
            for (let index = 0; index < this.memeberServicesCall.length; index++) {
                const element = this.memeberServicesCall[index];
                let promiseReturn: any;
                try {
                    promiseReturn = await element.toPromise();
                } catch (httpError) {
                    throw new Error(
                        this.resolveCreateMemberErrorMessage(httpError),
                    );
                }
                if (!promiseReturn?.customer) {
                    throw new Error(
                        this.resolveCreateMemberErrorMessage(promiseReturn),
                    );
                }
                // Only roll back members created in this attempt (not pre-existing updates)
                if (!formMembersSnapshot[index]?._id && promiseReturn.customer._id) {
                    createdCustomerIds.push(String(promiseReturn.customer._id));
                }
                res.push(promiseReturn);
            }

            const mongoDB_IDs = res.map((data) => ({
                id: data.customer._id,
                tagNumber: data.customer.tagNumber,
            }));

            if (this.relatedMemberData.length > 0 && this.subPackage.groupFeePayByOnePerson) {
                const relatedMemberGroup = {
                    members: this.relatedMemberData.map((r) => ({
                        memberId:
                            mongoDB_IDs.find((m) => m.tagNumber == r.tagNumber)?.id ??
                            r.memberId,
                        name: r.name,
                        phone: r.phone,
                        tagNumber: r.tagNumber,
                    })),
                    packageId: this.subPackage._id,
                    company: AuthService.getLoggedInCompany(),
                    branch: AuthService.getLoggedInBranch(),
                };

                try {
                    await this.appServiceManager
                        .post(
                            `branches/${AuthService.getLoggedInBranch()}/customers/actions/create-related-members-group`,
                            relatedMemberGroup,
                        )
                        .toPromise();
                } catch (error) {
                    throw new Error(
                        "Failed to save related member group: " +
                            this.resolveCreateMemberErrorMessage(error),
                    );
                }
            }

            this.members = [];
            let counter = 0;
            for (const data of res) {
                this.members.push(data.customer);
                if (this.uploadProfile[counter]) {
                    const file = AppUtils.base64ToFile(
                        this.uploadProfile[counter],
                        `${data.customer.name}.png` +
                            ":" +
                            this.user.company +
                            ":" +
                            this.user.branch,
                    );
                    this.uploadCustomerImage(file, data.customer);
                }
                counter++;
            }

            this.feeData.emit(this.members);
            this.changeTab();
            this.messageService.clear();
            this.messageService.add({
                severity: "success",
                summary: "Success Message",
                detail: "Member Successfully Registered",
            });
        } catch (error) {
            await this.rollbackCreatedMembers(createdCustomerIds);
            this.members = formMembersSnapshot;
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail:
                    (error instanceof Error ? error.message : String(error)) ||
                    "Member with same details already exists",
            });
        } finally {
            this.loader.hide();
        }
    }

    cancelSignupConfirmation(): void {
        this.registerConfirmVisible = false;
    }

    /** Duplicate tag / name+phone within the current registration batch. */
    private findDuplicateMemberDetailsError(): string | null {
        const tags = new Set<string>();
        const namePhone = new Set<string>();
        for (const member of this.members) {
            const tag = String(member?.tagNumber ?? "").trim();
            if (tag) {
                if (tags.has(tag)) {
                    return "Tag number is already assigned to another member";
                }
                tags.add(tag);
            }
            const name = String(member?.name ?? "").trim().toLowerCase();
            const phone = String(member?.contactDetail?.contact ?? "").trim();
            if (name && phone) {
                const key = `${name}|${phone}`;
                if (namePhone.has(key)) {
                    return "Member with same details already exists";
                }
                namePhone.add(key);
            }
        }
        return null;
    }

    private resolveCreateMemberErrorMessage(errorOrBody: any): string {
        const fromBody =
            errorOrBody?.error?.error ??
            errorOrBody?.error?.message ??
            (typeof errorOrBody?.error === "string" ? errorOrBody.error : null) ??
            errorOrBody?.message ??
            errorOrBody?.error;
        if (typeof fromBody === "string" && fromBody.trim()) {
            return fromBody.trim();
        }
        if (errorOrBody instanceof Error && errorOrBody.message) {
            return errorOrBody.message;
        }
        return "Member with same details already exists";
    }

    private async rollbackCreatedMembers(customerIds: string[]): Promise<void> {
        const branchId = AuthService.getLoggedInBranch();
        for (const id of customerIds) {
            if (!id) {
                continue;
            }
            try {
                await this.appServiceManager
                    .delete(`branches/${branchId}/customers/${id}`)
                    .toPromise();
            } catch (err) {
                console.error("Failed to roll back created member", id, err);
            }
        }
    }

    base64ToFile(data, filename) {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
                ;
        }
        return new File([u8arr], filename, { type: mime });
    }

    uploadCustomerImage(file: any, member, isAddMode = false) {
        let formData: FormData = new FormData();
        if (file) {

            formData.append("customerImage", file, file.name);
            formData.append("isThumb", "true");
            formData.append("memberId", member._id);
            formData.append("isAddMode", isAddMode.toString());
            formData.append("company", this.user.company);
            formData.append("branch", this.user.branch);


            this.appServiceManager.post(`branches/${AuthService.getLoggedInBranch()}/customers/upload`, formData)
                .subscribe(
                    (res: any) => {
                        member.profile=res.profile;
                        // this.members.push(member);
                        // this.feeData.emit(this.members);
                        // this.changeTab();
                    },
                    (error) => {
                        this.messageService.clear();
                        this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
                    }
                );
        }
    }

    changeTab() {
        this.changeWizard.emit();
    }

    feesUpdate() {
        if (this.subPackage.packageName !== "") {
            let packageMonths = 0;
            this.totalPackageFee = 0;
            for (let index = 0; index < this.members.length; index++) {
                let member = this.members[index];
                let memberPackage: IPackageBuider = this.subPackage;
                member.packageId = memberPackage._id;
                member.packageType = memberPackage.packageType;
                // Month Wise Package: per Month Fee and whole package fee.
                if (
                    memberPackage.packageType === "Month Wise Package" &&
                    memberPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                } else if (
                    memberPackage.packageType === "Month Wise Package" &&
                    memberPackage.packageFeeType === "per Month Fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee =
                        packageMonths * parseInt(member.monthFee);
                }
                // Person Wise Package: per person Fee and whole package fee.
                else if (
                    memberPackage.packageType === "Person Wise Package" &&
                    memberPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / memberPackage.noOfMembers
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                } else if (
                    memberPackage.packageType === "Person Wise Package" &&
                    memberPackage.packageFeeType === "per Person Fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee =
                        packageMonths * parseInt(member.monthFee);
                } else {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                }
            }
        }
    }

    membersAdd() {
        if (this.members.length === 0) {
            this.members.push(this.member);
        }
        this.memeberServicesCall = [];
        this.relatedMemberData = [];
        var check = true;
        let packageMonths = 0;
        this.members.forEach((member) => {
            if (this.subPackage.packageType === "Person Wise Package" && this.subPackage.packageFeeType === "whole package fee") {
                member.monthFee = Math.round(this.subPackage.packageFee / this.members.length).toString();
            }
            check = this.validateDetail(member);
            if (check) {
                this.setMemberData(member);
                if(this.members.length > 1 && this.subPackage.groupFeePayByOnePerson) {
                    const data = {
                        name: member.name,
                        memberId: member._id,
                        phone: member.contactDetail.contact,
                        packageId: member.packageId,
                        tagNumber: member.tagNumber
                    };
                    this.relatedMemberData.push(data);
                }
                member.company = AuthService.getLoggedInCompany();
                member.branch = AuthService.getLoggedInBranch();
                member.branchName = this.branch?.name || "";
                member.createdBy = this.user.name;
                member.type = 'Sign Up';
                member.scope = 'Member';
                member.initiatedFrom =  'Multiple Signup';
                if (member._id) {
                    //TODO: Existing member Update and add in package
                    this.memeberServicesCall.push(
                        this.appServiceManager.put(
                            customerUpdateUrl(AuthService.getLoggedInBranch(), member._id),
                            buildMemberUpdatePayload(member, {
                                modifiedBy: this.user?.name,
                                type: 'Sign Up',
                                includeCompanyBranch: true,
                            }),
                        )
                    );
                } else {
                    delete member.profile;
                    this.memeberServicesCall.push(
                        this.appServiceManager.post(
                            customerCreateUrl(AuthService.getLoggedInBranch()),
                            buildCreateCustomerPayload(member),
                        ),
                    );
                }
            } else {
                return (check = false);
            }
        });

        return check;
    }

    validateMember(newMember: MemberService) {
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = new Date();
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = new Date();
        } else {
            this.member.settings.dueDate = new Date(
                this.member.settings.dueDate
            );
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        } else if (
            this.member.emergencyContact.medicalDetail === null ||
            this.member.emergencyContact.medicalDetail === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }

    }
    setMemberData(member: IMember) {
        if (!member._id) {
            member.settings = new ISettings();
            member.settings.dueDate = new Date();
            this.freezeDetail.daysLeft = 0;
            this.freezeDetail.freezeDate = "";
            this.freezeDetail.isFreeze = false;
            this.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
            member.freezeDetail = this.freezeDetail;
            return;
        }

        // Existing members: keep due date and freeze state; only refresh package fee days allotment.
        if (!member.settings) {
            member.settings = new ISettings();
        }
        if (!member.freezeDetail) {
            member.freezeDetail = new IMemberFreezeDetail();
        }
        member.freezeDetail.totalFreezingDays = this.subPackage.freezingDays;
    }
    finish() {
        this.router.navigateByUrl("members");
    }
    clearProfile($event) {
        this.member.profile = "assets/layout/images/avatarBoyImage.png";
    }
    changeProfile() {
        setTimeout(() => {
            if (this.member.gender === "F") {
                if (this.member.profile.includes('avatarBoyImage.png')) {
                    this.member.profile =
                        "assets/layout/images/avatarGirlImage.png";
                }
            }
            else if (this.member.gender === "M") {
                if (this.member.profile.includes('avatarGirlImage.png')) {
                    this.member.profile = "assets/layout/images/avatarBoyImage.png";
                }
            }
        }, 300);
    }
    captureImageDialogShow(type) {
        this.addProfileImage = type; // Upload | Cam
        this.dialogVisibility = true;
    }
    hideAddProfileImage() {
        this.dialogVisibility = false;
    }

    handleImagefromNewProfile(webcamImage) {
        if (webcamImage) {
            this.uploadProfile[this.counterImage] = webcamImage;
            this.member.profile = webcamImage;
            console.log("this.company", this.user.company)
            console.log("this.company", this.user.branch)
            this.webcamImage = null;
            this.hideAddProfileImage();
        }
    }
    removeProfileImage() {
        this.uploadProfile = '';
        this.member.profile = '';
        if (this.member.gender === "F") {
            this.member.profile =
                "assets/layout/images/avatarGirlImage.png";
        } else {
            this.member.profile =
                "assets/layout/images/avatarBoyImage.png";
        }
    }
    handleImage(webcamImage: WebcamImage) {
        this.webcamImage = webcamImage;
        if (webcamImage) {
            this.uploadProfile = this.webcamImage;
            this.member.profile = this.webcamImage.imageAsDataUrl;
            this.webcamImage = null;
        }
    }
    feeChange() {
        if (this.fund.status === "Trainer Fee - Paid") {
            if (
                this.member.customerstrainer &&
                parseInt(this.member.customerstrainer.totalFees) > 0
            ) {
                this.fund.pay = parseInt(
                    this.member.customerstrainer.totalFees
                );
                this.fundInvoice.pay = parseInt(
                    this.member.customerstrainer.totalFees
                );
            } else {
                this.fund.pay = 0;
                this.fundInvoice.pay = 0;
            }
        } else if (this.fund.status === "Monthly Fee - Paid") {
            this.fund.pay = parseInt(this.member.monthFee);
            this.fundInvoice.pay = parseInt(this.member.monthFee);
        } else {
            this.fund.pay = 0;
            this.fund.pay = 0;
        }
    }
    dateChange() {
        this.fund.pay = parseInt(this.member.monthFee);
        this.fundInvoice.pay = parseInt(this.member.monthFee);
    }

    uniqueArrayOfObject(array, distinctMember) {
        // Filter by looking at the next objects if the object is present a second time
        array.forEach((data) => {
            if (data.error === "Fees Already Paid!") {
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: data.error + "of existing members",
                });
            } else {
                let member = distinctMember.find(
                    (x) => x._id == data.customer._id
                );
                if (!member) {
                    distinctMember.push(data.customer);
                }
            }
        });
        return distinctMember;
    }

    addFund() {
        this.dialogVisibility = false;
        this.confirmationService.confirm({
            message: "Are you sure you want to add member fee?",
            accept: () => {
                this.feeInvoiceDialog = false;
                if (this.members.length > 0) {
                    this.loader.show();
                    forkJoin(this.feesServicesCall).subscribe(
                        (res: any[]) => {
                            this.memeberServicesCall = [];
                            if (res) {
                                let distinctMembers: IMember[] = [];
                                distinctMembers = this.uniqueArrayOfObject(
                                    res,
                                    distinctMembers
                                );
                                distinctMembers.forEach((member) => {
                                    if (member._id) {
                                        this.memeberServicesCall.push(
                                            this.appServiceManager.get(
                                                customerGetUrl(AuthService.getLoggedInBranch(), member._id)
                                            )
                                        );
                                    }
                                });
                                this.getCustomerByID();
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Member Fee Submitted",
                                });
                                
                                this.activeIndex = 3;
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                                //this.feeInvoiceDialog = false;
                                this.activeIndex = 3;
                            }
                            this.loader.hide();
                        },
                        (error) => {
                            this.loader.hide();
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "warn",
                        summary: "Warning Message",
                        detail: "Monthly Fee Must be greater then zero.",
                    });
                    this.feeInvoiceDialog = false;
                    this.activeIndex = 4;
                }
            },
        });
    }

    async addExistngMember() {
        const member = this.existMembers.find(
            (x) => x._id === this.selectedExistMember
        );
        if (!member) {
            return;
        }

        const isSelectedMember = this.members.filter((x) => x._id === member._id);
        if (isSelectedMember.length > 0) {
            this.memberAlreadySelected = true;
            return;
        }

        this.loader.show();
        try {
            const eligibilityError =
                await this.validateExistingMemberForRegistration(member);
            if (eligibilityError) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: eligibilityError,
                });
                return;
            }

            this.member = member;
            if (!member.contactDetail) {
                member.contactDetail = new IMemberContact();
            }
            if (!member.contactDetail.address) {
                member.contactDetail.address = new IAddress();
                member.contactDetail.address.street = "";
            }
            this.member.tagNumber = member.tagNumber;
            this.member.registerationFee =
                this.subPackage.registerationFee.toString();
            // Package must already match — do not overwrite a different package.
            this.member.packageId = this.subPackage._id;
            this.member.packageLogo = this.subPackage.logo;
            this.member.packageType = this.subPackage.packageType;
            this.member.packageName = this.subPackage.packageName;
            if (!this.member.freezeDetail) {
                this.member.freezeDetail = new IMemberFreezeDetail();
            }
            this.member.freezeDetail.totalFreezingDays =
                this.subPackage.freezingDays;
            this.member.monthFee = this.subPackage.packageFee.toString();
            this.member.joiningDate = new Date(this.member.joiningDate);
            if (this.member.dateOfBirth) {
                this.member.dateOfBirth = new Date(this.member.dateOfBirth);
            }
            // Preserve billing due date for same-history / related-member rules.
            if (!this.member.settings) {
                this.member.settings = new ISettings();
            }
            if (member.settings?.dueDate) {
                this.member.settings.dueDate = new Date(member.settings.dueDate);
            }
            if (!this.member.customerstrainer) {
                this.member.customerstrainer = new Customerstrainer();
            }
            this.member.customerstrainer.totalFees = undefined;
            this.member.gPTQuestion = "";
            this.existingMembersDialog = false;
            this.selectedExistMember = undefined;
            this.member.question3 = "NO";
            this.member.CNIC = member.CNIC;
            this.dbEmailIfCustomerHAve =
                member.email && member.email.length > 0 ? member.email : undefined;

            if (!this.member.emergencyContact) {
                this.member.emergencyContact = new IMemberEmergencyContact();
            }
            if (!this.member.emergencyContact.medicalDetail) {
                this.member.emergencyContact.medicalDetail = "";
            }

            this.onDateOfBirthChange();
            this.autoFocus();
        } finally {
            this.loader.hide();
        }
    }

    private isSameHistoryPackage(): boolean {
        const pkg = this.subPackage;
        if (!pkg) {
            return false;
        }
        return !!(
            pkg.groupFeePayByOnePerson &&
            (pkg.noOfMembers ?? 0) > 1 &&
            (pkg.sameHistory === true || (pkg.sameHistory as unknown) === "true")
        );
    }

    /**
     * Always: same package, not in another group.
     * sameHistory: no open partial; paid-through must not be ahead of anchor due date.
     */
    private async validateExistingMemberForRegistration(
        member: IMember,
        anchorDueDateOverride?: Date | null,
    ): Promise<string | null> {
        if (!member?._id) {
            return "Selected member is invalid";
        }
        if (member.isDelete) {
            return "Selected member is deleted";
        }
        if (String(member.packageId) !== String(this.subPackage?._id)) {
            return "Selected member has different package";
        }
        if (member.relatedMembersId) {
            return "Selected member is already part of another group";
        }

        if (!this.isSameHistoryPackage()) {
            return null;
        }

        try {
            const res: any = await this.appServiceManager
                .post(
                    billingStatusUrl(AuthService.getLoggedInBranch()),
                    buildBillingStatusPayload(String(member._id), false),
                )
                .toPromise();
            const data = res?.data ?? res;
            if (
                data?.isPartial === true ||
                String(data?.status) === "Partial"
            ) {
                return "Selected member has an open partial fee for the current period";
            }

            const anchorDue =
                anchorDueDateOverride ??
                this.resolveRegistrationAnchorDueDate(String(member._id));
            if (!anchorDue) {
                return null;
            }

            // Paid-through only applies when the current cycle is fully paid.
            const fullyPaid =
                String(data?.status) === "Paid" ||
                (Number(data?.amountDue) === 0 &&
                    String(data?.status) !== "Unpaid" &&
                    !!data?.billingPeriodEnd);
            if (!fullyPaid) {
                return null;
            }

            const paidThrough = parseLocalBillingDate(data?.billingPeriodEnd);
            if (paidThrough && paidThrough.getTime() > anchorDue.getTime()) {
                return "Cannot add member to same-history group: their paid billing period extends beyond the group due date.";
            }
        } catch (error) {
            return this.resolveCreateMemberErrorMessage(error);
        }

        return null;
    }

    private resolveRegistrationAnchorDueDate(
        excludeMemberId?: string,
    ): Date | null {
        const pool = (this.members || []).filter(
            (m) => m && String(m._id || "") !== String(excludeMemberId || ""),
        );
        const anchor = pool[0];
        if (!anchor) {
            return null;
        }
        return (
            parseLocalBillingDate(anchor.settings?.dueDate) ??
            parseLocalBillingDate(anchor.joiningDate)
        );
    }

    private async validateExistingMembersBeforeSignup(): Promise<string | null> {
        const existing = (this.members || []).filter((m) => !!m?._id);
        if (existing.length === 0) {
            return null;
        }
        const primary = this.members[0];
        const primaryIsExisting =
            !!primary?._id &&
            existing.some((m) => String(m._id) === String(primary._id));
        const anchorForOthers =
            parseLocalBillingDate(primary?.settings?.dueDate) ??
            parseLocalBillingDate(primary?.joiningDate);

        for (const member of existing) {
            const isPrimary = String(member._id) === String(primary?._id);
            const anchor = isPrimary
                ? primaryIsExisting
                    ? this.resolveRegistrationAnchorDueDate(String(member._id))
                    : null
                : anchorForOthers;
            const err = await this.validateExistingMemberForRegistration(
                member,
                anchor,
            );
            if (err) {
                return err;
            }
        }
        return null;
    }

    AddExistingOnchange() {
        this.memberAlreadySelected = false;
    }
    getCustomerByID() {
        this.members = [];
        forkJoin(this.memeberServicesCall).subscribe(
            (res: any) => {
                if (res) {
                    res.forEach((member) => {
                        member.joiningDate = new Date(member.joiningDate);
                        this.members.push(member);
                    });
                    this.getCompany();
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }

    onDateOfBirthChange() {
        const currentDate = new Date();
        if(this.member.dateOfBirth && new Date(this.member.dateOfBirth) > currentDate){
            this.dateOfBirthError = true;
        }else{
            this.dateOfBirthError = false;
        }
        this.getPackageByID();
        if(this.selectecPackage && this.selectecPackage.ageGroupFrom){
            this.loading = true;
            setTimeout(() => {
            this.checkAgeGroup();
        }, 1000);
        }
    }

    checkAgeGroup() {
        const validation = AppUtils.validateMemberAgeAgainstPackage(this.member, this.selectecPackage);
        if (validation.isValid) {
            console.log('Age is within the package age group.');
            this.isAgeValid = true;
        } else {
            this.isAgeValid = false;
            this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail:  "This package is not for this age group",
                    });
        }
    }

    searchLocal(value, type) {
        let matchedPackage = [];

        if (
            value !== null &&
            value !== undefined &&
            value.toString().length > 0
        ) {
            if (value == "") {
                this.packages = Object.assign([], this.sourcePackages);
            }
            if (!value) {
                this.packages = Object.assign([], this.sourcePackages);
            }
            if (value != "") {
                if (type === "name") {
                    matchedPackage = Object.assign(
                        [],
                        this.sourcePackages
                    ).filter((pack) =>
                        pack.packageName
                            ? pack.packageName
                                .toLowerCase()
                                .indexOf(value.toLowerCase()) > -1
                            : null
                    );
                }
                const distinct = (value, index, self) => {
                    return self.indexOf(value) === index;
                };
                // const source = matchedPackage.concat(matchedPackage);
                this.packages = matchedPackage.filter(distinct);

                if (this.packages.length === 0) {
                    this.packages = [];
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Packages Record Found",
                    });
                } else {
                    this.packages = [...this.packages];
                }
            }
        } else {
            this.packages = Object.assign([], this.sourcePackages);
            this.packages = [...this.packages];
        }
    }

    printInvoice(): void {
        this.receiptComponent.printInvoice();
    }

    printCard(membercard) {
        let membercardDetail = this.members.find(
            (x) => x.tagNumber == membercard.tagNumber
        );
        this.member = membercardDetail;
        setTimeout(() => {
            this.print();
        }, 200);
    }

    // firstFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 0) {
    //         e.preventDefault();
    //         setTimeout(() => {
    //             this.genderControl.nativeElement.focus();
    //         }, 3000);
    //         return;
    //     }
    // }

    // secondFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13) {
    //         e.preventDefault();
    //         control = document.getElementById("contact").focus();
    //         return;
    //     } else if (e.keyCode == 113 && this.index == 0) {
    //         this.existingMembersDialog = true;
    //         return;
    //     }
    // }
    // thirdFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 0) {
    //         e.preventDefault();
    //         control = document.getElementById("street");
    //         control.focus();
    //         return;
    //     } else if (e.keyCode == 113 && this.index == 0) {
    //         this.existingMembersDialog = true;
    //         return;
    //     }
    // }

    // phoneToEmailFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 0) {
    //         e.preventDefault();
    //         control = document.getElementById("email");
    //         control.focus();
    //         return;
    //     } else if (e.keyCode == 113 && this.index == 0) {
    //         this.existingMembersDialog = true;
    //         return;
    //     }
    // }

    // fourthFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 0) {
    //         e.preventDefault();
    //         control = document.getElementById("city");
    //         control.focus();
    //         return;
    //     } else if (e.keyCode == 113 && this.index == 0) {
    //         this.existingMembersDialog = true;
    //         return;
    //     }
    // }

    // fifthFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 0) {
    //         e.preventDefault();
    //         control = document.getElementById("country");
    //         control.focus();
    //         return;
    //     } else if (e.which == 113 || e.keyCode == 113) {
    //         this.existingMembersDialog = true;
    //         return;
    //     }
    // }

    // sixthFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 0) {
    //         e.preventDefault();
    //         control = document.getElementById("description");
    //         control.focus();
    //         return;
    //     } else if (e.which == 113 || e.keyCode == 113) {
    //         this.existingMembersDialog = true;
    //         return;
    //     }
    // }

    // trainerFeeFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 1) {
    //         e.preventDefault();
    //         control = document.getElementById("trainerFee");
    //         control.focus();
    //         return;
    //     }
    // }
    // trainerShareFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 1) {
    //         e.preventDefault();
    //         control = document.getElementById("trainerShare");
    //         control.focus();
    //         return;
    //     }
    // }

    // gymShareFocus(e) {
    //     let control: any;
    //     if (e.keyCode == 13 && this.index == 1) {
    //         e.preventDefault();
    //         control = document.getElementById("gymShare");
    //         control.focus();
    //         return;
    //     }
    // }

    // commentToMemberNameFocus($event) {
    //     if ($event.keyCode == 13 && !$event.shiftKey) {
    //         $event.preventDefault();
    //         let control: any;
    //         control = document.getElementById("memberName").focus();
    //     }
    // }

    // hotkeys($event) {

    //     if ($event.keyCode == 70 && this.activeIndex == 3) {
    //         this.finish();
    //     }
    //     else if ($event.keyCode == 80 && this.activeIndex == 3) {
    //         this.printInvoice();
    //     }
    //     else if ($event.shiftKey && $event.keyCode == 39 && this.activeIndex == 1 && this.index == 0) {
    //         let ele: any = document.getElementById("nextMember");
    //         if (!ele.disabled) {
    //             this.nextMembers();
    //         }
    //     }
    //     else if ($event.ctrlKey && $event.keyCode == 13 && this.activeIndex == 1 && this.index == 0) {
    //         let ele: any = document.getElementById("proceedButton");
    //         if (!ele.disabled) {
    //             this.validateMembersSignup();
    //         }
    //     }
    //     else if ($event.ctrlKey && $event.keyCode == 13 && this.activeIndex == 1 && this.index == 1) {
    //         let ele: any = document.getElementById("registerButton");
    //         if (!ele.disabled) {
    //             this.signup();
    //         }
    //     }
    //     else if ($event.keyCode == 113 && this.activeIndex == 1 && this.index == 0) {
    //         this.existingMembersDialog = true;
    //     }
    //     else if ($event.keyCode == 27 && this.activeIndex == 1 && this.index == 0) {
    //         let ele: any = document.getElementById("escButton");
    //         if (!ele.disabled) {
    //             this.skipMember();
    //         }
    //     }
    // }

    print(): void {
        let printContents, popupWin;
        printContents = document.getElementById("ID-card").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>Gym ID Card</title>
        <style>
            .ID-card {
                width: 400px;
                height: 250px;
                margin: auto;
                position: relative;
                padding: 20px;
                border-radius: 10px;
                background-image: url("https://i.ibb.co/NL188dQ/white-wood.png");
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.35);
                z-index: 10;
                filter: opacity(95%);
            }

            .top-row {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 5px 0;
            }

            .flag {
                height: 10px;
                margin-right: 5px;
            }

            .card-title,
            .card-title-en {
                line-height: 100%;
            }

            .name,
            .name-en,
            .ID-number {
                font-weight: normal;
            }

            .card-title-en {
                margin-left: auto;
            }

            .middle-row {
                margin-top: 30px;
                display: inline-block;
            }

            .bottom-row {
                position: absolute;
                bottom: 20px;
            }

            .ID-photo {
                display: block;
                width: 100px;
                height: 128px;
                background-repeat: no-repeat;
                background-position: -90px center;
                background-size: 250px;
                position: absolute;
                top: 60px;
                right: 20px;
            }

            .series-number {
                writing-mode: vertical-rl;
                transform: rotate(180deg);
                position: absolute;
                right: -20px;
                bottom: 66px;
                z-index: 10;
            }

            .signature-title {
                position: absolute;
                bottom: 20px;
                right: 20px;
            }

            .signature {
                font-family: "Liu Jian Mao Cao", cursive;
                font-weight: 100;
                position: absolute;
                right: 40px;
                bottom: 35px;
            }

            .ID-number {
                line-height: 100%;
                margin-top: 5px;
            }

            .title {
                text-align: center;
                margin: 16px;
                font-weight: normal;
                font-size: 16px;
                width: 100%;
                position: absolute;
                bottom: 20px;
                z-index: 10;
            }
        </style>
    </head>
    <body>
        ${printContents}</body>
    </html>
    `);
    }

    checkEmailExistence() {
        if (this.member.email != undefined && this.member.email.length > 0 && !this.isPreviouslyAddedEmailsMatchWithCurrentOne) {
            this.isEmailLoader = true;
            const data = { email: this.member.email };
            this.appServiceManager.post(
                'branches/' + this.user.branch + '/customers/actions/check-email-existence',
                data,
            ).subscribe(
                (member: any) => {
                    if (member.isEmailExist) {
                        this.isEmailExist = true;
                        this.isDisableOnTypeEmail = true;
                        setTimeout(() => {
                            this.isEmailLoader = false;

                        }, 1000);
                    } else {
                        this.isEmailExist = false;
                        this.isDisableOnTypeEmail = false;

                        setTimeout(() => {
                            this.isEmailLoader = false;
                        }, 2000);
                    }
                },
                (error) => {

                }
            );
        }

    }

    checkEmailExistEvent(e) {
        var check = this.members.filter(x => x.email === e.target.value);
        if (check.length > 0) {
            this.isEmailExist = true;
            this.isDisableOnTypeEmail = true;
            this.isPreviouslyAddedEmailsMatchWithCurrentOne = true;
        } else {
            this.isPreviouslyAddedEmailsMatchWithCurrentOne = false;
            this.isDisableOnTypeEmail = true;
            if (e.target.value.length > 0 && e.target.value != this.dbEmailIfCustomerHAve) {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.checkEmailExistence()
                }, 1000);
            } else {
                clearTimeout(this.timer);
                this.isEmailExist = false;
                this.isDisableOnTypeEmail = false;
            }
        }
    }


    selectTrainerFocusOnGroupTrainingPage() {
        let ele: any = document.getElementById(this.enterSteps[0])
        if (ele != null && ele != undefined && this.index == 1) {
            let ele = document.getElementById(this.enterSteps[0]).children[0] as HTMLElement;
            ele.click();
            this.currentStep = 0;
        }
    }


    getTrainerShare() {
        var x = parseInt(this.members[this.key].customerstrainer.totalFees) - parseInt(this.members[this.key].customerstrainer.gymShare);
        if (isNaN(x)) {
            this.members[this.key].customerstrainer.trainerShare = undefined;
            this.isGymShareMoreThanTrainerFee = true;
        } else {
            if (x >= 0) {
                this.members[this.key].customerstrainer.trainerShare = x.toString();
                this.isGymShareMoreThanTrainerFee = false;

            } else {
                this.members[this.key].customerstrainer.trainerShare = undefined;
                this.isGymShareMoreThanTrainerFee = true;
            }
        }
    }

    onChangeTrainerFee(e) {
        var x = parseInt(this.members[this.key].customerstrainer.totalFees)
        if (isNaN(x)) {
            // this.isGymShareMoreThanTrainerFee = true;
            e.target.value = '0';
            this.members[this.key].customerstrainer.totalFees = '0';
            this.members[this.key].customerstrainer.trainerShare = '0';
            this.members[this.key].customerstrainer.gymShare = '0';
        } else {
            if (x >= 0) {
                this.members[this.key].customerstrainer.trainerShare = '0';
                this.members[this.key].customerstrainer.gymShare = '0';
                this.isGymShareMoreThanTrainerFee = false;

            } else {
                this.members[this.key].customerstrainer.trainerShare = '0';
                this.members[this.key].customerstrainer.gymShare = '0';
                this.isGymShareMoreThanTrainerFee = true;
            }
        }

    }

    addExistingMemberDropdownClick() {
        let ele: any = document.getElementById("aEM")
        if (ele != null && ele != undefined && this.index == 0) {
            let ele = document.getElementById("aEM").children[0] as HTMLElement;
            ele.click();
        }
    }



    hotkeys($event) {
        if ($event.keyCode == 13 && this.activeIndex == 1 && !$event.shiftKey && !$event.ctrlKey && !this.existingMembersDialog) {
            var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
            var nextId = this.enterSteps[nextStep];
            let ele: any = document.getElementById(nextId)
            if (nextId == "gender") {
                let radioClassFocus: any = document.getElementsByClassName("p-highlight")[1] as HTMLElement;
                radioClassFocus.click();
                this.currentStep = 1;
            } if (nextId == "question1") {
                let radioClassFocus: any = document.getElementsByClassName("p-highlight")[2] as HTMLElement;
                radioClassFocus.click();
                this.currentStep = 7;
            } else if (ele != null && this.index == 1 && nextId == this.enterSteps[0]) {
                let ele = document.getElementById(this.enterSteps[0]).children[0] as HTMLElement;
                ele.click();
                this.currentStep = 0;
            } else if (ele != null && ele.disabled && this.index == 1 && (nextId == this.enterSteps[1] || nextId == this.enterSteps[2] || nextId == this.enterSteps[3])) {
                let ele = document.getElementById(this.enterSteps[0]).children[0] as HTMLElement;
                ele.click();
                this.currentStep = 0;
            } else if (ele != null) {
                ele.focus();
                this.currentStep = nextStep;
            }
        }
        else if (this.index == 1 && $event.ctrlKey && $event.keyCode == 13 && !this.existingMembersDialog) {
            let ele: any = document.getElementById("registerButton");
            if (ele != null && !ele.disabled) {
                ele.click();
            }
        } else if (this.index == 1 && $event.shiftKey && $event.keyCode == 13 && !this.existingMembersDialog) {
            this.key = this.members.length - 1 > this.key ? this.key + 1 : 0;
            this.enterSteps = [
                "selectTrainer-" + this.key,
                "trainerFees-" + this.key,
                "gymShare-" + this.key,
                "trainerShare-" + this.key,
            ];
            this.selectTrainerFocusOnGroupTrainingPage();
        }
        else if (this.index == 0 && this.activeIndex == 1 && $event.shiftKey && $event.keyCode == 39 && !this.existingMembersDialog) {
            let ele: any = document.getElementById("nextMember");
            if (ele != null && !ele.disabled) {
                this.nextMembers();
            }
        } else if (this.index == 0 && this.activeIndex == 1 && $event.ctrlKey && $event.keyCode == 13 && !this.existingMembersDialog) {
            let ele: any = document.getElementById("proceedButton");
            if (ele != null && !ele.disabled) {
                this.validateMembersSignup(this.memberSignUpForm);
            }
        } else if ($event.keyCode == 27 && this.index == 0 && !this.existingMembersDialog) {
            let ele: any = document.getElementById("escButton");
            if (ele != null && !ele.disabled) {
                this.skipMember();
            }
        } else if ($event.keyCode == 113 && this.index == 0 && !this.existingMembersDialog) {
            this.existingMembersDialog = true;
            if (this.existingMembersDialog) {
                setTimeout(() => {
                    this.addExistingMemberDropdownClick();
                }, 700);
            } else {
                return;
            }
        } else if (($event.keyCode == 17 || $event.ctrlKey) && this.index == 0 && this.existingMembersDialog) {
            this.addExistingMemberDropdownClick();
        } else if ($event.keyCode == 13 && this.index == 0 && this.existingMembersDialog) {
            let ele: any = document.getElementById("addExisMemberSave");
            if (ele != null && !ele.disabled) {
                this.addExistngMember();
            }
        }
    }

    hotClick($event) {
        let currentClickLocation = $event.target.id;
        let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
        if (!$event.target.disabled && ($event.target.id.includes("trainerFees-") || $event.target.id.includes("gymShare-") || $event.target.id.includes("trainerShare-"))) {
            this.key = $event.target.id.slice(-1);
            this.enterSteps = [
                "selectTrainer-" + this.key,
                "trainerFees-" + this.key,
                "gymShare-" + this.key,
                "trainerShare-" + this.key,
            ];
            let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
            this.currentStep = indexOfClickField;
        } else if ($event.target.id.includes("rowTrainer-")) {
            this.key = $event.target.id.slice(-1);
            this.enterSteps = [
                "selectTrainer-" + this.key,
                "trainerFees-" + this.key,
                "gymShare-" + this.key,
                "trainerShare-" + this.key,
            ];
        } else if (indexOfClickField !== -1 && (currentClickLocation != "opt1" || currentClickLocation != "opt2")) {
            this.currentStep = indexOfClickField;
        } else {
            this.currentStep = this.currentStep;
        }
    }
}
